import React from 'react'
import { animated, config, useSpring } from 'react-spring'

import Panel, { PanelLevel } from '@cinch/oxd-components/panel/src'

import * as styles from './fieldset.module.css'

interface FieldSetProps {
  title: string
  remainingSteps: number
  aside?: React.ReactNode
  isFirstPage: boolean
  intro?: string
}

const FieldSet: React.FC<FieldSetProps> = ({ children, title, intro, remainingSteps, aside, isFirstPage }) => {
  const cfg = {
    config: config.gentle,
    from: { transform: 'perspective(700px) translate3d(0, -30px, -30px)' },
    to: { transform: 'perspective(700px) translate3d(0, 0, 0)' },
  } as any

  if (remainingSteps === 0) {
    cfg.from = { ...cfg.from, opacity: 0.5 }
    cfg.to = { ...cfg.to, opacity: 1 }
  }

  const styleProps = useSpring(cfg)
  const animateIn = useSpring({
    config: config.gentle,
    from: { opacity: 0 },
    to: { opacity: 1 },
  })

  return (
    <animated.div style={styleProps}>
      <Panel level={PanelLevel.top} className={styles.panel} isPadded={false} isBodyFlex={true}>
        <div className={styles.innerPanel}>
          {!!aside && <aside className={styles.panelAside}>{aside}</aside>}
          <div className={styles.panelMain}>
            {isFirstPage && <p className={styles.firstPageIntro}>{intro}</p>}
            <header className={styles.title}>{title}</header>
            {children}
          </div>
        </div>
        {remainingSteps > 0 && <div className={styles.b} />}
        {remainingSteps > 1 && <animated.div style={animateIn} className={styles.c} />}
      </Panel>
    </animated.div>
  )
}

export default FieldSet
